import * as _ from "lodash";
import * as angular from "angular";
import { VoterFileImport } from "../../models/voter-file-import.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { Utils } from "../../helper/utils.helper";
import { CredentialsManager } from "../../shared/credentials-manager";
import { PermissionCheck } from "../../shared/permission";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ConsentType } from "../../models/consent-type.model";

let VoterFileImportInfoComponent = {
    selector: "vcVoterFileImportInfo",
    templateUrl:
        "/angular/components/voter-file/voter-file-import-info.component.html",
    bindings: {},
    controller: class VoterFileImportInfoComponentController {
        private $http: any;
        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        public readonly __env: any;
        private $routeParams: any;
        private $window: any;
        private toast: ToastUtils;
        public import: VoterFileImport | null = null;
        public warning = false;
        public stats = false;
        public statsObj: object;
        public activeCampaign: Campaign;
        public mappedColumns: any = [];
        public mappingOpened = false;
        public loading = true;
        public readonly isLeaderView: boolean;
        private credentialsManager: CredentialsManager;
        private dataProvider: VoterFileDataProvider;
        private fieldDataProvider: FieldDataProvider;
        private permissionProvider: PermissionCheck;

        constructor(
            __env: any,
            $scope: any,
            $routeParams: any,
            VoterFileDataProvider: VoterFileDataProvider,
            FieldDataProvider: FieldDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            Utils: Utils,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            PermissionCheck: PermissionCheck,
            CredentialsManager: CredentialsManager,
            $window: any,
            $filter: any,
            $http: any,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.$routeParams = $routeParams;
            this.__env = __env;
            this.$window = $window;
            this.toast = ToastUtils;
            this.credentialsManager = CredentialsManager;
            this.isLeaderView = __app_type === "LEADER";
            NavigationBarHelperService.setShowBackButton(true);
            this.$http = $http;
            this.dataProvider = VoterFileDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.permissionProvider = PermissionCheck;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            // The background delete job reports back over the socket
            const stopListening = VoterFileDataProvider.onImportSocket(
                (operation: string, socketData: any) =>
                    this.onImportSocket(operation, socketData)
            );
            $scope.$on("$destroy", stopListening);
            if (this.$routeParams.imid) {
                VoterFileDataProvider.importInfo(this.$routeParams.imid).then(
                    (imp: VoterFileImport) => {
                        this.import = imp;
                        this.loading = false;
                        this.import.getFileData().then(() => {
                            imp.getMapping().then(() => {
                                for (let i = 0; i < imp.mapping.length; i++) {
                                    let index = Utils.getNumberFromName(
                                        imp.mapping[i].icvalue
                                    );
                                    this.mappedColumns.push({
                                        fileData: imp.data[index],
                                        column: imp.mapping[i],
                                    });
                                }
                            });
                        });
                    },
                    () => {
                        this.import = null;
                        this.loading = false;
                        ToastUtils.error();
                    }
                );
            } else {
                VoterFileDataProvider.info(this.$routeParams.erid).then(
                    (voterFile: VoterFileImport) => {
                        this.import = voterFile;
                        this.loading = false;
                    },
                    () => {
                        this.import = null;
                        this.loading = false;
                        ToastUtils.error();
                    }
                );
            }
        }

        download(): void {
            const file = this.isLeaderView
                ? "/api/organisation/voterfile/download/" +
                  this.import.erid +
                  "/?oid=" +
                  this.credentialsManager.oid
                : "/api/voterfile/download/" +
                  this.import.erid +
                  "/?campaignid=" +
                  this.credentialsManager.campaignid;

            if (!this.import.imid || this.import.file.erfiletype == "xlsx") {
                this.$window.location = file;
                return;
            }
            this.$http.get(file).then((response) => {
                var blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                var url = window.URL.createObjectURL(blob);
                var link = document.createElement("a");
                link.href = url;
                let name = this.import.name();
                if (
                    !(name.indexOf(".csv") > -1) &&
                    !(name.indexOf(".xlsx") > -1)
                ) {
                    name += this.import.fileExtension();
                }
                link.download = name;
                link.click();
            });
        }

        importVoterFile(ev): void {
            if (this.activeCampaign.inEssentialsMode()) {
                this.dialog.show({
                    component: "vc-feature-disabled-dialog",
                    targetEvent: ev,
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        essentials: true,
                    },
                });
            } else {
                if (this.isLeaderView) {
                    this.$window.location =
                        "./leader.php/#/leader_voterfiles/import/" +
                        this.import.erid +
                        (this.import.imid ? "/" + this.import.imid : "");
                } else {
                    this.$window.location =
                        "./#/voterfiles/import/" +
                        this.import.erid +
                        (this.import.imid ? "/" + this.import.imid : "");
                }
            }
        }

        editImportName($event?: any): void {
            const parentEl = angular.element(document.body);
            this.dialog
                .show({
                    parent: parentEl,
                    targetEvent: $event,
                    component: "vc-edit-import-name",
                    locals: {
                        import: this.import,
                        backendUpdate: !!this.import.imid,
                    },
                    clickOutsideToClose: true,
                })
                .then((imp: VoterFileImport) => {
                    this.import = imp;
                    this.dataProvider.replaceVoterFile(this.import);
                });
        }

        columnDisplayName(column: any): string | null {
            return this.fieldDataProvider.columnDisplayName(column);
        }

        deleteData($event: any): void {
            this.dialog
                .show({
                    component: "vc-delete-import-data-dialog",
                    targetEvent: $event,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        import: this.import,
                    },
                    ariaLabel: `Delete Import Data`,
                    style: "max-width: 550px",
                })
                .then(() => {
                    this.dataProvider.deleteImportData(this.import.imid).then(
                        (imp: VoterFileImport) => {
                            if (imp) {
                                this.setImportState(imp);
                                this.dataProvider.replaceVoterFile(imp);
                            }
                            // Finishes in a background job
                            this.toast.success(
                                "Deleting import data. Contacts and houses from this import are being removed from your campaign. This may take a few minutes."
                            );
                        },
                        (error: any) => this.toast.error(error)
                    );
                });
        }

        private onImportSocket(operation: string, socketData: any): void {
            if (!this.import?.imid || socketData?.imid != this.import.imid) {
                return;
            }
            if (operation === "delete") {
                this.setImportState({ ...socketData, status: "Deleted" });
            } else if (operation === "update" && socketData.status) {
                this.setImportState(socketData);
            }
        }

        // Only the status and who changed it when, so the file data and
        // mapping already loaded on this.import are kept
        private setImportState(data: any): void {
            this.$scope.$evalAsync(() => {
                if (!this.import) {
                    return;
                }
                this.import.status = data.status;
                for (const field of [
                    "lastmodifieddatetime",
                    "lastupdater",
                    "updater",
                ]) {
                    if (data[field] !== undefined) {
                        (this.import as any)[field] = data[field];
                    }
                }
            });
        }
    },
};

angular
    .module("voterFile")
    .component(
        VoterFileImportInfoComponent.selector,
        VoterFileImportInfoComponent
    );
